import React, { useEffect, useRef, useState } from 'react';
import BackButton from '../components/BackButton';
import { useLocation } from 'react-router-dom';
import { updateSingleVideoStatus } from '../Firebase'

export default function GeneratedVideo() {

    const location = useLocation();
    const { videourl, id, uuid, selectedPill } = location.state || {}; // Access the passed video URL


    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [pageLoader, setPageLoader] = useState(false)
    const [proccessingVideo, setProccessingVideo] = useState(false)
    const [videourl_status, setVideourl_status] = useState("")

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };


    useEffect(() => {
        const updateVideoStatus = async () => {
            try {
                console.log("ID: ", id);
                console.log("uuid: ", uuid);
                console.log("category: ", selectedPill);
                setPageLoader(true);

                // Call the async function
                const videostatus = await updateSingleVideoStatus(selectedPill, uuid, id);
                console.log("video status :", videostatus)
                if (videostatus === 0) {
                    setProccessingVideo(true)
                } else {
                    console.log("new video url : ", videostatus[id].video_url)
                    setVideourl_status(videostatus[id].video_url)
                    setProccessingVideo(false)
                }
            } catch (error) {
                console.error("Error updating video status:", error);
            } finally {
                setPageLoader(false); // Stop loader after the operation
            }
        };

        updateVideoStatus();
    }, []); // Pass dependencies if needed, e.g., [id, uuid, selectedPill]



    const closeAlert = () => {
        setProccessingVideo(false);
    };
    return (
        <div className='d-flex flex-column justify-content-between' style={{ height: '90vh' }}>
            <div className='container pt-4 p-0'>
                <BackButton title="Generated Video" />
            </div>

            {proccessingVideo ? (
                <div
                    className="container alert alert-warning alert-dismissible fade show mt-2"

                    role="alert"
                >
                    <h3>Your video is still being processed</h3>

                </div>
            ) : (
                <div className="video-container container" style={{ position: 'relative', width: '100%' }}>
                    <video
                        ref={videoRef}
                        src={videourl ? videourl : videourl_status}
                        onClick={handlePlayPause}
                        onPlay={() => setIsPlaying(true)}
                        onPause={() => setIsPlaying(false)}
                        style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            objectFit: 'cover',
                        }}
                    />
                    {pageLoader ? (
                        <span className="Spinloader"></span>
                    ) : (
                        !isPlaying && (
                            <div
                                className="play-button-overlay"
                                onClick={handlePlayPause}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    borderRadius: '8px',
                                    height: '100%',
                                }}
                            >
                                <button
                                    className="play-button"
                                    style={{
                                        width: '45px',
                                        height: '45px',
                                        borderRadius: '50%',
                                        paddingLeft: '10px',
                                        border: 'none',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        fontSize: '27px',
                                        textAlign: 'center',
                                        color: 'black',
                                        fontWeight: 'bold',
                                        cursor: 'pointer',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                                    }}
                                >
                                    ▶
                                </button>
                            </div>
                        )
                    )}
                </div>
            )}



            <div className='container'>
                {!pageLoader && !proccessingVideo ? (
                    <button
                        className='main-button'
                        onClick={() => {
                            const link = document.createElement('a');
                            link.href = videourl;
                            link.download = 'GeneratedVideo.mp4';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            alert("Video Downloaded")
                        }}
                        style={{ width: "100%", marginTop: '20px' }}
                    >
                        Download Video
                    </button>
                ) : ""}


            </div>
        </div>
    );
}
